import { render, staticRenderFns } from "./SwiperPeopleThree.vue?vue&type=template&id=d575eb18&"
import script from "./SwiperPeopleThree.vue?vue&type=script&lang=js&"
export * from "./SwiperPeopleThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports